import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});

/* Storage bucket name — must exist in Supabase (public read + admin write) */
export const PROPERTIES_BUCKET = "properties";

/* Public URL helper */
export const publicUrl = (path) => {
  if (!path) return "";
  // If it's already an absolute URL (external CDN), pass through.
  if (/^https?:\/\//i.test(path)) return path;
  const { data } = supabase.storage.from(PROPERTIES_BUCKET).getPublicUrl(path);
  return data?.publicUrl || "";
};
